/* 🤖 this file was generated by svg-to-ts */
export const rpgAwesomeIconButterfly: {
  name: 'butterfly';
  data: string;
} = {
  name: 'butterfly',
  data: `<svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" x="0" y="0" version="1.1" viewBox="0 0 613 613"><path d="M595.111 261.065c-108.923-60.99-229.115-39.065-320.618 56.85 108.506 59.582 229.691 38.738 320.618-56.85zM69.325 47.222c119.285 33.677 188.28 133.481 185.204 265.086C136.527 277.939 66.071 178.194 69.325 47.222zM266.659 340.406c102.005 40.374 135.212 122.683 90.045 218.86-100.569-40.717-135.178-123.168-90.045-218.86zM247.628 333.725c-99.161-40.691-180.852-5.47-218.417 92.469 98.418 39.48 181.174 5.11 218.417-92.469z"/></svg>`,
};
